import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Grid,
  Card,
  CardContent,
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Divider,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
  Chat as ChatIcon,
  AccountCircle as AccountCircleIcon,
  CalendarToday as CalendarTodayIcon,
  Payment as PaymentIcon,
  Home as HomeIcon,
  Save as SaveIcon,
  Delete as DeleteIcon, // Import Delete Icon
} from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";


// Helper function to get the day name from a date
const getDayName = (date) => {
  const daysOfWeek = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
  return daysOfWeek[new Date(date).getDay()];
};


const AdminChrono = () => {
  const navigate = useNavigate();
  const [lessons, setLessons] = useState([]);
  const [instructors, setInstructors] = useState([]);
  const [newLesson, setNewLesson] = useState({
    title: "",
    description: "",
    date: "",
    time: "",
    duration: "",
    instructor_id: "",
  });
  const baseUrl = process.env.REACT_APP_APP_URL;

  const token = localStorage.getItem("CC_Token");
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user ? user.id : null;

  // Fetch lessons and instructors when component mounts
  useEffect(() => {
    if (!token || !userId) {
      console.error("Token or User ID is missing.");
      return;
    }

    const fetchLessons = async () => {
      try {
        const lessonsResponse = await axios.get(`${baseUrl}/api/lessons`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLessons(lessonsResponse.data);
      } catch (error) {
        console.error("Error fetching lessons:", error);
      }
    };

    const fetchInstructors = async () => {
      try {
        const instructorsResponse = await axios.get(`${baseUrl}/api/users/instructor`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setInstructors(instructorsResponse.data.instructors); // Corrected: use the right data field
      } catch (error) {
        console.error("Error fetching instructors:", error);
      }
    };

    fetchLessons();
    fetchInstructors();
  }, [token, userId]);

  // Handle input changes for new lesson
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewLesson((prev) => ({ ...prev, [name]: value }));
  };

  // Save a new lesson
  const handleSaveLesson = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/lessons`,
        {
          title: newLesson.title,
          description: newLesson.description,
          date: newLesson.date,
          time: newLesson.time,
          duration: newLesson.duration,
          instructor_id: newLesson.instructor_id,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Add the instructor information directly to the lesson object
      const newLessonWithInstructor = {
        ...response.data,
        instructor: instructors.find(instructor => instructor.id === response.data.instructor_id) || {},
      };

      setLessons((prev) => [...prev, newLessonWithInstructor]);
      setNewLesson({ title: "", description: "", date: "", time: "", duration: "", instructor_id: "" });
    } catch (error) {
      console.error("Error saving lesson:", error);
    }
  };

  // Delete a lesson by its ID
  const handleDeleteLesson = async (lessonId) => {
    try {
      await axios.delete(`${baseUrl}/api/lessons/${lessonId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // Remove the deleted lesson from the state
      setLessons((prev) => prev.filter((lesson) => lesson.id !== lessonId));
    } catch (error) {
      console.error("Error deleting lesson:", error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("CC_Token");
    localStorage.removeItem("user");
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    });
    setTimeout(() => navigate("/login"), 4000); // Redirect after toast
  };

  const handleNavigateToNotifications = () => {
    navigate("/AdminGetNotifs");
  };
  const handleProfile = () => {
  user.role === "admin" ? navigate("/ProfileAdmin") : navigate("/Profile");
};

  // Group lessons by day of the week
  const groupedLessons = lessons.reduce((acc, lesson) => {
    const day = getDayName(lesson.date);
    if (!acc[day]) acc[day] = [];
    acc[day].push(lesson);
    return acc;
  }, {});

  return (
    <div>
      <ToastContainer />
      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar
            alt="Logo"
            src={"../assets/cej.png"}
            sx={{ width: 40, height: 40, marginRight: "0.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ padding: "2rem", backgroundColor: "#f9f9f9", overflowX: { xs: "hidden", md: "auto" } }}>
        <Typography variant="h4" sx={{ textAlign: "center", marginBottom: "2rem", color: "#002244", fontWeight: 700 }}>
           
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card sx={{ padding: "1rem" }}>
              <CardContent>
                <Typography variant="h6" sx={{ marginBottom: "1rem", textAlign: "center" }}>
                  Ajouter une Leçon
                </Typography>
                <TextField
                  label="Titre"
                  variant="outlined"
                  fullWidth
                  name="title"
                  value={newLesson.title}
                  onChange={handleInputChange}
                  sx={{ marginBottom: "1rem" }}
                />
                <TextField
                  label="Description Générale"
                  variant="outlined"
                  fullWidth
                  name="description"
                  value={newLesson.description}
                  onChange={handleInputChange}
                  sx={{ marginBottom: "1rem" }}
                />
                <TextField
                  label="Date"
                  type="date"
                  variant="outlined"
                  fullWidth
                  name="date"
                  value={newLesson.date}
                  onChange={handleInputChange}
                  sx={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  label="Heure"
                  type="time"
                  variant="outlined"
                  fullWidth
                  name="time"
                  value={newLesson.time}
                  onChange={handleInputChange}
                  sx={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  label="Description"
                  type="text"
                  variant="outlined"
                  fullWidth
                  name="duration"
                  value={newLesson.duration}
                  onChange={handleInputChange}
                  sx={{ marginBottom: "1rem" }}
                />
                <TextField
                  label="coach"
                  variant="outlined"
                  fullWidth
                  select
                  name="instructor_id"
                  required
                  value={newLesson.instructor_id}
                  onChange={handleInputChange}
                  sx={{ marginBottom: "1rem" }}

                >
                  {instructors.map((instructor) => (
                    <MenuItem key={instructor.id} value={instructor.id}>
                      {instructor.name}
                    </MenuItem>
                  ))}
                </TextField>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<SaveIcon />}
                  onClick={handleSaveLesson}
                  fullWidth
                  disabled = {newLesson.instructor_id==""}
                >
                  Enregistrer Leçon
                </Button>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={8}>
            <Grid container spacing={3} sx={{ display: "flex", flexWrap: { xs: "wrap", md: "nowrap" }, justifyContent: { xs: "center", md: "flex-start" }, overflowX: { md: "auto" }, gap: { md: "1rem" } }}>
              {["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"].map((day) => (
                <Grid item xs={12} sm={6} md={3} key={day} sx={{ flex: { md: "1 1 calc(100% / 7)" }, minWidth: { md: "200px" } }}>
                  <Box sx={{ backgroundColor: "#ffffff", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", overflow: "hidden" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        padding: "1rem",
                        backgroundColor: "#002244",
                        color: "#ffffff",
                        fontWeight: "bold",
                      }}
                    >
                      {day}
                    </Typography>
                    <Divider />
                    <Box sx={{ padding: "1rem" }}>
                      {groupedLessons[day] && groupedLessons[day].length > 0 ? (
                        groupedLessons[day].map((lesson) => (
                          <Card key={lesson.id} sx={{ marginBottom: "1rem" }}>
                            <CardContent>
                              <Typography variant="h6">{lesson.title}</Typography>
                              <Typography variant="body2" color="textSecondary">{lesson.description}</Typography>
                              <Typography variant="body2" color="textSecondary">{lesson.time}</Typography>
                              <Typography variant="body2" color="error">{lesson.duration}</Typography>
                              <Typography variant="body2" color="textSecondary">{lesson.instructor.name}</Typography>
                              <Button
                                variant="outlined"
                                color="error"
                                startIcon={<DeleteIcon />}
                                onClick={() => handleDeleteLesson(lesson.id)}
                                sx={{ marginTop: "0.5rem" }}
                              >
                                Supprimer
                              </Button>
                            </CardContent>
                          </Card>
                        ))
                      ) : (
                        <Typography variant="body2" color="textSecondary" sx={{ textAlign: "center" }}>
                          Aucune leçon pour ce jour
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>

    {/* Footer */}
          <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
            <BottomNavigation
              sx={{
                backgroundColor: "#003366",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <BottomNavigationAction
                label="Calendrier"
                icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                sx={{ color: "#ffffff", minWidth: "auto" }}
                onClick={() => navigate("/AdminChrono")
                }
              />
              <BottomNavigationAction
                label="Home"
                icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                sx={{ color: "#ffffff", minWidth: "auto" }}
                onClick={() => navigate(user.role === "admin" ? "/admin" : "/InstructorHome")
                }
              />
              <BottomNavigationAction
                label="Paiement"
                icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                sx={{ color: "#ffffff", minWidth: "auto" }}
                  onClick={() => navigate(user.role === "admin" ? "/AdminPaiment" : "/InstructorHome")
                }
              />
            </BottomNavigation>
          </Box>
        </div>
      );
    };
    

export default AdminChrono;
